module.exports = __webpack_public_path__ + "img/Stack_2.b51c55f8.png";